import * as React from "react";
import { ScrollUpSymbol } from "ui/common/icons/scroll-up-symbol";
import styles from "./scroll-to-top.scss";

// find nearest scrollable parent
function getScrollParent(el: HTMLElement | null): HTMLElement | Window {
  if (!el) {return window}

  let parent: HTMLElement | null = el.parentElement;
  while (parent) {
    const style = window.getComputedStyle(parent);
    const isScrollable = /(auto|scroll)/.test(style.overflowY);
    if (isScrollable && parent.scrollHeight > parent.clientHeight) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return window;
}

export const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = React.useState(false);
  const containerRef = React.useRef<HTMLElement | Window>(window);
  const selfRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (selfRef.current) {
      containerRef.current = getScrollParent(selfRef.current);
    }

    const el = containerRef.current;
    const handleScroll = () => {
      const offset = el instanceof Window ? el.pageYOffset : el.scrollTop;
      setVisible(offset > 0);
    };

    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll as EventListener);
  }, []);

  const scrollUp = () => {
    const el = containerRef.current;
    if (el instanceof Window) {
      el.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      el.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div ref={selfRef}>
      <ScrollUpSymbol
        onClick={scrollUp}
        className={`${styles.button} ${visible ? styles.visible : ""}`}
      />
    </div>
  );
};
